import styled from 'styled-components'

export const StyledSymbols = styled.div`
    
`

export const StyledSymbolsHeader = styled.div`
    font-size: 20px;
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    color: ${({ theme }) => theme.greyishBrown};
    text-align: center;
    margin-bottom: 25px;
`

export const StyledSymbolsList = styled.ul`
    padding: 0;
    margin: 0;
`

export const StyledSymbolsItem = styled.li`
    display: flex;
    align-items: center;
    margin-bottom: 25px;
`

export const StyledText = styled.div`
    font-size: 14px;
    font-weight: ${({ theme }) => theme.fontWeight.regular};
    color: ${({ theme }) => theme.greyishBrown};
    margin-left: 30px;
`